/*=========================================================================================
  File Name: main.js
  Description: main vue(js) file
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import { createApp } from "vue";
import App from "./App.vue";
import themeConfig, { colors } from "../themeConfig.js";

import "material-icons/iconfont/material-icons.css";
import "vuesax/dist/vuesax.css";

import VueApexCharts from "vue3-apexcharts";
import permissionHandler from "./mixins/permissionHandler";
import registerGlobalComponents from "./globalComponents.js";

import "./assets/scss/main.scss";
import "@/assets/css/tailwind-v1.min.css";
import "@/assets/css/main.css";

import router from "./router";
import store from "./store/store";
import hammer from "./directives/hammer";
import i18n from "./localization/localization";

import { createCurrencyFormatter } from "./utils/formatCurrency.mjs";
import { createMomentFormatter } from "./utils/formatMoment.mjs";
import { installVsCore } from "./plugins/vsCore";
import { installVsLoading } from "./plugins/vsLoading";
import { installVsNotify } from "./plugins/vsNotify";
import { VueReCaptcha } from "vue-recaptcha-v3";

require("./assets/css/iconfont.css");

let currencyOptions = {
  symbol: "SEK",
  thousandsSeparator: ",",
  fractionCount: 2,
  fractionSeparator: ".",
  symbolPosition: "before",
  symbolSpacing: true,
};
if (localStorage.getItem("currency")) {
  currencyOptions.symbol = JSON.parse(
    localStorage.getItem("currency")
  ).codename;
}

const app = createApp(App);

app.config.warnHandler = () => {};
installVsCore(app, { colors, rtl: themeConfig.rtl });
installVsLoading(app);
installVsNotify(app);
app.directive("hammer", hammer);
app.config.globalProperties.$formatCurrency =
  createCurrencyFormatter(currencyOptions);
app.config.globalProperties.$formatMoment = createMomentFormatter();
app.use(router);
app.use(store);
app.use(i18n);
app.use(VueReCaptcha, {
  siteKey: "6LcuAqYZAAAAAG8O8mX0Tudbk4UADbI9uDsXVmFj",
});
app.mixin(permissionHandler);
app.component("apexchart", VueApexCharts);
registerGlobalComponents(app);
app.mount("#app");
